import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (27 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisSozlesme = {

  UploadWarehouseCompanyAgreement(token, companyID, document, type) {
    return axios({
      method: "post",
      url: `${API_URL}flow/upload-warehouse-company-agreement`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        document,
        type
      }
    });
  },

  GetWarehouseCompanyAgreements(token, companyID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouse-company-agreements`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID
      }
    });
  },

  GetAgreementsList(token, { signal } = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-agreements-list`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      signal
    });
  },

  GetContractTemplates(token, payload = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-contract-templates`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload && typeof payload === "object" ? payload : {}
    });
  },

  GetContracts(token, payload = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-contracts`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: payload && typeof payload === "object" ? payload : {}
    });
  },

  // İmzalı sözleşme dosyası yükleme (çizerek imzalamaya alternatif).
  // file: { file: base64, name, extension }
  UploadSignedContract(token, contractID, file) {
    return axios({
      method: "post",
      url: `${API_URL}flow/upload-signed-contract`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { contractID, file }
    });
  },

  // İmzayı siler (yalnızca admin): sözleşme "İmza Bekliyor"a döner, imzalar/yüklenen dosya kalkar.
  ClearContractSignature(token, contractID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/clear-contract-signature`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { contractID }
    });
  },

  // Yüklenen imzalı sözleşmeyi reddeder (admin / ilgili merchant) → sözleşme "İmza Bekliyor"a döner.
  RejectUploadedContract(token, contractID, rejectionReason = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/reject-uploaded-contract`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { contractID, ...(rejectionReason ? { rejectionReason } : {}) }
    });
  },

  // Yüklenen imzalı sözleşmeyi onaylar (admin / ilgili merchant).
  ApproveUploadedContract(token, contractID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/approve-uploaded-contract`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { contractID }
    });
  },

  SignContract(token, contractID, signatures = [], saveAsDefault = false) {
    const data = {
      contractID,
      signatures: Array.isArray(signatures) ? signatures : [],
      saveAsDefault: Boolean(saveAsDefault),
    };

    return axios({
      method: "post",
      url: `${API_URL}flow/sign-contract`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data
    });
  },

  MerchantSignContract(token, contractID, signatures = [], saveAsDefault = false) {
    const data = {
      contractID,
      signatures: Array.isArray(signatures) ? signatures : [],
      saveAsDefault: Boolean(saveAsDefault),
    };

    return axios({
      method: "post",
      url: `${API_URL}flow/merchant-sign-contract`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data
    });
  },

  SaveSignature(token, signatureBase64) {
    return axios({
      method: "post",
      url: `${API_URL}flow/save-signature`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        signatureBase64
      }
    });
  },

  GetMySignature(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-my-signature`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {}
    });
  },

  RemoveSignature(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-signature`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {}
    });
  },

  // Firma profili > Müşteri Sözleşmeleri: firmanın "bilgilendirildi" kayıtları.
  // İşaretleme yalnız firmanın KENDİ kullanıcısı içindir (admin okuduğunda firma
  // bilgilendirilmiş sayılmaz — sunucu da bunu reddeder).
  GetFirmAgreementReads(token, corporationId) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-firm-agreement-reads`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { corporationId },
    });
  },

  MarkFirmAgreementRead(token, corporationId, agreementKey) {
    return axios({
      method: "post",
      url: `${API_URL}flow/mark-firm-agreement-read`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { corporationId, agreementKey },
    });
  },

  // Firma yetkilisi müşteri sözleşme metnini %80 okuyup "Okudum, onaylıyorum" der.
  ApproveFirmAgreement(token, corporationId, agreementKey) {
    return axios({
      method: "post",
      url: `${API_URL}flow/approve-firm-agreement`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { corporationId, agreementKey },
    });
  },

  // --- Firma (merchant) imzası: firmanın tüm sözleşmelerinde otomatik görünür ---
  GetCompanySignature(token, companyID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-company-signature`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: companyID ? { companyID } : {}
    });
  },

  // İmza yetkilisinin adı soyadı (Firma Profili imza/kaşe bölümü).
  SetCompanySignatureAuthority(token, authorityName, companyID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/set-company-signature-authority`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { authorityName, ...(companyID ? { companyID } : {}) }
    });
  },

  SaveCompanySignature(token, signatureBase64, companyID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/save-company-signature`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { signatureBase64, ...(companyID ? { companyID } : {}) }
    });
  },

  // İmza yetkilisi adının admin onayı: approved=true → kilit, false → onayı kaldır (tekrar düzenlenebilir).
  ReviewCompanySignatureAuthority(token, companyID, approved) {
    return axios({
      method: "post",
      url: `${API_URL}flow/review-company-signature-authority`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { companyID, approved: Boolean(approved) }
    });
  },

  RemoveCompanySignature(token, companyID = "") {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-company-signature`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: companyID ? { companyID } : {}
    });
  },

  RemoveWarehouseCompanyAgreements(token, companyID, fileID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-warehouse-company-agreement`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        fileID
      }
    });
  },

  UpdateAgreementStatus(token, fileID, status) {
    return axios({
      method: "post",
      url: `${API_URL}flow/company-agreement-change-status`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        fileID,
        status
      }
    });
  },

  MarkOperationContractSigned(token, operationID, payload = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        ...(payload && typeof payload === "object" ? payload : {}),
        operationID,
        status: 7,
      }
    });
  },

  MarkOperationContractWaiting(token, operationID, payload = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        ...(payload && typeof payload === "object" ? payload : {}),
        operationID,
        status: 6,
      }
    });
  },
  
  GetNotificationTemplates(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-notification-templates`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
};

export default servisSozlesme;
